var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "AddSubscribeOrderdemodialog",
          attrs: {
            title: _vm.$t("subscribe.title"),
            visible: _vm.isShowSubscribe,
            "before-close": _vm.subscribeClose,
            width: "90%",
            top: "1vh",
            "append-to-body": "",
            "modal-append-to-body": ""
          },
          on: { open: _vm.open }
        },
        [
          _c(
            "el-form",
            {
              ref: "subscribeOrder",
              staticClass: "demo-shopform",
              attrs: {
                model: _vm.subscribeOrder,
                inline: true,
                "label-width": "200px"
              }
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("subscribe.labellist[3]"),
                    prop: "name"
                  }
                },
                [
                  _c("el-input", {
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.subscribeOrder.num,
                      callback: function($$v) {
                        _vm.$set(_vm.subscribeOrder, "num", $$v)
                      },
                      expression: "subscribeOrder.num"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("subscribe.labellist[2]"),
                    prop: "applydt"
                  }
                },
                [
                  _c("el-input", {
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.subscribeOrder.applydt,
                      callback: function($$v) {
                        _vm.$set(_vm.subscribeOrder, "applydt", $$v)
                      },
                      expression: "subscribeOrder.applydt"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("subscribe.labellist[18]"),
                    prop: "purchaseType"
                  }
                },
                [
                  _c("el-input", {
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.subscribeOrder.purchaseType,
                      callback: function($$v) {
                        _vm.$set(_vm.subscribeOrder, "purchaseType", $$v)
                      },
                      expression: "subscribeOrder.purchaseType"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("subscribe.labellist[7]"),
                    rules: {
                      required: true,
                      message: _vm.$t("subscribe.errmsg[1]")
                    }
                  }
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "190px" },
                      attrs: {
                        disabled: _vm.isEdit === true || _vm.isLook === true,
                        placeholder: _vm.$t("SupplierClass.placeholder")
                      },
                      on: { change: _vm.currencyChange },
                      model: {
                        value: _vm.subscribeOrder.currencyid,
                        callback: function($$v) {
                          _vm.$set(_vm.subscribeOrder, "currencyid", $$v)
                        },
                        expression: "subscribeOrder.currencyid"
                      }
                    },
                    _vm._l(_vm.currencyList, function(item, index) {
                      return _c("el-option", {
                        key: item + index,
                        attrs: { label: item.ShortEng, value: item.id }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("GoodsList.dialog[14]"),
                    rules: {
                      required: true,
                      message:
                        _vm.$t("GoodsList.dialog[14]") +
                        " " +
                        _vm.$t("depart.msg[1]")
                    }
                  }
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "190px" },
                      attrs: {
                        placeholder: _vm.$t("SupplierClass.placeholder"),
                        disabled: _vm.isEdit == true || _vm.isLook === true
                      },
                      on: { change: _vm.purchaseCategoryChange },
                      model: {
                        value: _vm.subscribeOrder.purid,
                        callback: function($$v) {
                          _vm.$set(_vm.subscribeOrder, "purid", $$v)
                        },
                        expression: "subscribeOrder.purid"
                      }
                    },
                    _vm._l(_vm.purchaseClass, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.purgoods_En, value: item.id }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              false
                ? _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("subscribe.labellist[21]") } },
                    [
                      _c("el-input", {
                        attrs: {
                          value:
                            _vm.subscribeOrder.budgetMoney +
                            _vm.deptBudget.shortEng,
                          disabled: ""
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("subscribe.labellist[25]") } },
                [
                  _vm.deptBudget.length > 0
                    ? _c("el-input", {
                        attrs: {
                          value:
                            _vm.isEdit || _vm.isLook
                              ? _vm.subscribeOrder.budgetMoney +
                                _vm.deptBudget[0].shortEng
                              : _vm.CurrentBudgetAmount +
                                _vm.deptBudget[0].shortEng,
                          disabled: ""
                        }
                      })
                    : _c("el-input", {
                        attrs: {
                          value:
                            _vm.isEdit || _vm.isLook
                              ? _vm.subscribeOrder.budgetMoney
                              : _vm.CurrentBudgetAmount,
                          disabled: ""
                        }
                      })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("subscribe.labellist[26]") } },
                [
                  _c("el-input", {
                    attrs: {
                      value:
                        _vm.isEdit || _vm.isLook
                          ? _vm.subscribeOrder.money
                          : _vm.OrderTTLAmount,
                      disabled: ""
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    disabled:
                      _vm.isLook === true ||
                      _vm.subscribeOrder.isComplete !== 0,
                    label: _vm.$t("subscribe.labellist[32]"),
                    rules: {
                      required: true,
                      message:
                        _vm.$t("subscribe.labellist[32]") +
                        " " +
                        _vm.$t("depart.msg[1]")
                    }
                  }
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "190px" },
                      attrs: {
                        disabled:
                          _vm.isLook === true ||
                          _vm.subscribeOrder.isComplete !== 0
                      },
                      on: { change: _vm.laborGroupChange },
                      model: {
                        value: _vm.subscribeOrder.GroupName,
                        callback: function($$v) {
                          _vm.$set(_vm.subscribeOrder, "GroupName", $$v)
                        },
                        expression: "subscribeOrder.GroupName"
                      }
                    },
                    _vm._l(_vm.UserGroupList, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.groupName, value: item.id }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  staticClass: "formtable",
                  staticStyle: { width: "100%" },
                  attrs: { label: "" }
                },
                [
                  _c(
                    "el-table",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        data: _vm.deptBudget,
                        "empty-text": _vm.$t("header.tableEmpty"),
                        stripe: "",
                        border: ""
                      }
                    },
                    [
                      _vm._l(_vm.tableHead, function(item, index) {
                        return _c("el-table-column", {
                          key: index,
                          attrs: {
                            "show-overflow-tooltip": "",
                            align: "center",
                            prop: item.prop,
                            label: item.label,
                            width: "200"
                          }
                        })
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          label: _vm.$t("subscribe.labellist[24]"),
                          prop: "withoutAfterAmount",
                          "show-overflow-tooltip": ""
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c(
                                  "div",
                                  {
                                    style: {
                                      color:
                                        scope.row.redtext == true
                                          ? "#ff0000"
                                          : "#000000"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t\t" +
                                        _vm._s(scope.row.withoutAfterAmount) +
                                        "\n\t\t\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          label: _vm.$t("subscribe.labellist[23]"),
                          prop: "ApprovedAmount",
                          "show-overflow-tooltip": ""
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          label: _vm.$t("subscribe.statelist[9]"),
                          prop: "currentBudgetAmount",
                          "show-overflow-tooltip": ""
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          label: _vm.$t("subscribe.labellist[7]"),
                          prop: "shortEng",
                          "show-overflow-tooltip": ""
                        }
                      })
                    ],
                    2
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  staticClass: "formtable",
                  staticStyle: { width: "100%" },
                  attrs: { label: "" }
                },
                [
                  _c(
                    "el-table",
                    {
                      staticStyle: { width: "100%", overflow: "auto" },
                      attrs: {
                        "empty-text": _vm.$t("header.tableEmpty"),
                        stripe: "",
                        border: "",
                        "max-height": "350",
                        data: _vm.subscribeOrder.GoodsList
                      }
                    },
                    [
                      _c(
                        "el-table-column",
                        {
                          attrs: { "show-overflow-tooltip": "" },
                          scopedSlots: _vm._u([
                            {
                              key: "header",
                              fn: function(scope) {
                                return [
                                  _c(
                                    "div",
                                    { staticStyle: { display: "flex" } },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                scope.row == null ||
                                                scope.row.status === 0 ||
                                                scope.row.status === 23,
                                              expression:
                                                "scope.row == null || scope.row.status === 0 || scope.row.status === 23"
                                            }
                                          ],
                                          attrs: { type: "primary" },
                                          on: {
                                            click: function($event) {
                                              _vm.FisShowGoods = true
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t\t\t" +
                                              _vm._s(
                                                _vm.$t("subscribe.caozuo[1]")
                                              ) +
                                              "\n\t\t\t\t\t\t\t\t\t"
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            type: "success",
                                            icon: "el-icon-upload2"
                                          },
                                          on: { click: _vm.exportAsSampleExcel }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("subscribe.button[3]")
                                            )
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("select-excel", {
                                        attrs: {
                                          label: _vm.$t("subscribe.button[2]"),
                                          "on-success": _vm.importSuccess,
                                          "before-upload":
                                            _vm.importFromSampleExcel
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("get-goods-list", {
                                        attrs: {
                                          isShowGoods: _vm.FisShowGoods,
                                          Stypename: _vm.currentPurchaseClass,
                                          purchaseType: _vm.purchaseType,
                                          arrData: _vm.subscribeOrder.GoodsList,
                                          projectId:
                                            _vm.subscribeOrder.ProjectID,
                                          getTitle: _vm.FitemGetTitle
                                        },
                                        on: {
                                          "update:isShowGoods": function(
                                            $event
                                          ) {
                                            _vm.FisShowGoods = $event
                                          },
                                          "update:is-show-goods": function(
                                            $event
                                          ) {
                                            _vm.FisShowGoods = $event
                                          },
                                          "update:Stypename": function($event) {
                                            _vm.currentPurchaseClass = $event
                                          },
                                          "update:stypename": function($event) {
                                            _vm.currentPurchaseClass = $event
                                          },
                                          selectGoods: _vm.chooseGoods,
                                          closeShowGoods: function($event) {
                                            _vm.FisShowGoods = false
                                          },
                                          "update:getTitle": function($event) {
                                            _vm.FitemGetTitle = $event
                                          },
                                          "update:get-title": function($event) {
                                            _vm.FitemGetTitle = $event
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              }
                            }
                          ])
                        },
                        [
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: _vm.$t("subscribe.labellist[9]"),
                              prop: "Goods.num",
                              "show-overflow-tooltip": ""
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          cursor: "pointer",
                                          color: "#409EFF",
                                          "text-decoration": "underline"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.handleCellClick(
                                              scope.row
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v(_vm._s(scope.row.Goods.num))]
                                    )
                                  ]
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: _vm.$t("subscribe.labellist[10]"),
                              width: "100",
                              prop: "Goods.name",
                              "show-overflow-tooltip": ""
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("subscribe.labellist[36]"),
                              width: "100",
                              prop: "Goods.localDes",
                              "show-overflow-tooltip": "",
                              align: "center"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: _vm.$t("subscribe.labellist[11]"),
                              prop: "count",
                              width: "150",
                              "show-overflow-tooltip": ""
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _vm.subscribeOrder.isComplete === 0 ||
                                    _vm.subscribeOrder.id === 0 ||
                                    _vm.subscribeOrder.status === 0 ||
                                    _vm.subscribeOrder.status === 23
                                      ? _c("el-input", {
                                          staticStyle: { width: "100%" },
                                          attrs: { type: "number", min: "0" },
                                          on: { blur: _vm.inputNum },
                                          model: {
                                            value: scope.row.count,
                                            callback: function($$v) {
                                              _vm.$set(scope.row, "count", $$v)
                                            },
                                            expression: "scope.row.count"
                                          }
                                        })
                                      : _c("el-input", {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            type: "number",
                                            disabled: ""
                                          },
                                          model: {
                                            value: scope.row.count,
                                            callback: function($$v) {
                                              _vm.$set(scope.row, "count", $$v)
                                            },
                                            expression: "scope.row.count"
                                          }
                                        })
                                  ]
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              width: "200",
                              label: _vm.$t("subscribe.labellist[19]"),
                              prop: "requestReason",
                              "show-overflow-tooltip": "",
                              required: ""
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _vm.isLook == false
                                      ? _c(
                                          "el-select",
                                          {
                                            staticStyle: { width: "100%" },
                                            model: {
                                              value: scope.row.requestReason,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  scope.row,
                                                  "requestReason",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "scope.row.requestReason"
                                            }
                                          },
                                          _vm._l(
                                            _vm.requestReasonList,
                                            function(itemName, index2) {
                                              return _c("el-option", {
                                                key: itemName + index2,
                                                attrs: {
                                                  label: itemName.name,
                                                  value: itemName.name
                                                }
                                              })
                                            }
                                          ),
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.isLook == true
                                      ? _c(
                                          "el-select",
                                          {
                                            staticStyle: { width: "100%" },
                                            attrs: { disabled: "" },
                                            model: {
                                              value: scope.row.requestReason,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  scope.row,
                                                  "requestReason",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "scope.row.requestReason"
                                            }
                                          },
                                          _vm._l(
                                            _vm.requestReasonList,
                                            function(itemName, index2) {
                                              return _c("el-option", {
                                                key: itemName + index2,
                                                attrs: {
                                                  label: itemName.name,
                                                  value: itemName.name
                                                }
                                              })
                                            }
                                          ),
                                          1
                                        )
                                      : _vm._e()
                                  ]
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              width: "200",
                              label: _vm.$t("subscribe.labellist[29]"),
                              prop: "Disagreereason",
                              "show-overflow-tooltip": "",
                              required: ""
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _vm.auditstatu > 1 &&
                                    _vm.auditid > 0 &&
                                    _vm.isApprove
                                      ? _c(
                                          "el-select",
                                          {
                                            staticStyle: { width: "100%" },
                                            model: {
                                              value: scope.row.Disagreereason,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  scope.row,
                                                  "Disagreereason",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "scope.row.Disagreereason"
                                            }
                                          },
                                          _vm._l(
                                            _vm.disagreereasonList,
                                            function(itemName, index2) {
                                              return _c("el-option", {
                                                key: itemName + index2,
                                                attrs: {
                                                  label: itemName.name,
                                                  value: itemName.name
                                                }
                                              })
                                            }
                                          ),
                                          1
                                        )
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(scope.row.Disagreereason)
                                          )
                                        ])
                                  ]
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: _vm.$t("GoodsList.dialog[23]"),
                              prop: "AccountNO",
                              width: "110",
                              "show-overflow-tooltip": "",
                              required: ""
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: {
                                          filterable: "",
                                          disabled:
                                            _vm.isLook == false &&
                                            _vm.isPurchaserOrFinicial == false
                                        },
                                        on: {
                                          change: function(val) {
                                            return _vm.ACnameChange(
                                              scope.row,
                                              val
                                            )
                                          }
                                        },
                                        model: {
                                          value: scope.row.AccountNO,
                                          callback: function($$v) {
                                            _vm.$set(
                                              scope.row,
                                              "AccountNO",
                                              $$v
                                            )
                                          },
                                          expression: "scope.row.AccountNO"
                                        }
                                      },
                                      _vm._l(_vm.acname, function(item, index) {
                                        return _c("el-option", {
                                          key: index,
                                          attrs: {
                                            label: item.AccountNO,
                                            value: item.AccountNO
                                          }
                                        })
                                      }),
                                      1
                                    )
                                  ]
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: _vm.$t("GoodsList.dialog[27]"),
                              width: "120",
                              prop: "AccountName",
                              "show-overflow-tooltip": ""
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: _vm.$t(
                                "DepartBudgetBalanceRpt.tableLabel[2]"
                              ),
                              width: "120",
                              prop: "BudgetType",
                              "show-overflow-tooltip": ""
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: _vm.$t("subscribe.labellist[12]"),
                              prop: "Goods.unit",
                              "show-overflow-tooltip": ""
                            }
                          }),
                          _vm._v(" "),
                          _vm.UnitPricePermission
                            ? _c("el-table-column", {
                                attrs: {
                                  align: "center",
                                  label: _vm.$t("GoodsList.dialog[4]"),
                                  prop: "price",
                                  "show-overflow-tooltip": "",
                                  formatter: _vm.tableFormat
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.UnitPricePermission
                            ? _c("el-table-column", {
                                attrs: {
                                  align: "center",
                                  label: _vm.$t("GoodsList.dialog[28]"),
                                  prop: "totalAmount",
                                  "show-overflow-tooltip": "",
                                  formatter: _vm.tableFormat
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              width: "130",
                              label: _vm.$t("subscribe.labellist[16]"),
                              prop: "ShipmentDate",
                              formatter: _vm.tableFormat,
                              "show-overflow-tooltip": ""
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              width: "130",
                              label: _vm.$t("subscribe.labellist[20]"),
                              prop: "supplierCode",
                              "show-overflow-tooltip": ""
                            }
                          }),
                          _vm._v(" "),
                          _vm.UnitPricePermission
                            ? _c("el-table-column", {
                                attrs: {
                                  align: "center",
                                  label: _vm.$t("subscribe.labellist[6]"),
                                  prop: "supplierAbbr",
                                  "show-overflow-tooltip": ""
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              width: "120",
                              label: _vm.$t("GoodsList.dialog[21]"),
                              prop: "Goods.NeedInspect",
                              "show-overflow-tooltip": ""
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: _vm.$t("subscribe.labellist[7]"),
                              prop: "shortEng",
                              "show-overflow-tooltip": ""
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _vm.subscribeOrder.isComplete === 0 ||
                                    _vm.subscribeOrder.status === 23
                                      ? _c(
                                          "el-button",
                                          {
                                            attrs: { type: "danger" },
                                            on: {
                                              click: function($event) {
                                                return _vm.deleteItemRecord(
                                                  scope.row
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t\t\t" +
                                                _vm._s(
                                                  _vm.$t("subscribe.caozuo[2]")
                                                ) +
                                                "\n\t\t\t\t\t\t\t\t\t"
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                }
                              }
                            ])
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("subscribe.labellist[4]"),
                    prop: "explain"
                  }
                },
                [
                  _vm.isLook == false
                    ? _c("el-input", {
                        staticStyle: { width: "555px" },
                        attrs: { type: "textarea" },
                        model: {
                          value: _vm.subscribeOrder.explain,
                          callback: function($$v) {
                            _vm.$set(_vm.subscribeOrder, "explain", $$v)
                          },
                          expression: "subscribeOrder.explain"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isLook == true
                    ? _c("el-input", {
                        staticStyle: { width: "555px" },
                        attrs: { type: "textarea", disabled: "" },
                        model: {
                          value: _vm.subscribeOrder.explain,
                          callback: function($$v) {
                            _vm.$set(_vm.subscribeOrder, "explain", $$v)
                          },
                          expression: "subscribeOrder.explain"
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("subscribe.labellist[0]") } },
                [
                  _c("el-input", {
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.subscribeOrder.optname,
                      callback: function($$v) {
                        _vm.$set(_vm.subscribeOrder, "optname", $$v)
                      },
                      expression: "subscribeOrder.optname"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("subscribe.labellist[1]") } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "200px", "margin-right": "20px" },
                      attrs: {
                        disabled:
                          _vm.userData === null ||
                          _vm.userData.deptData.chooseOtherDept !== 1 ||
                          _vm.isLook == true ||
                          _vm.subscribeOrder.isComplete !== 0
                      },
                      model: {
                        value: _vm.base_deptname,
                        callback: function($$v) {
                          _vm.base_deptname = $$v
                        },
                        expression: "base_deptname"
                      }
                    },
                    [
                      _c(
                        "el-option",
                        {
                          staticStyle: {
                            height: "auto",
                            "background-color": "white"
                          },
                          model: {
                            value: _vm.base_deptnameid,
                            callback: function($$v) {
                              _vm.base_deptnameid = $$v
                            },
                            expression: "base_deptnameid"
                          }
                        },
                        [
                          _c("department-tree", {
                            attrs: { isshowTitle: false },
                            on: { selectTreeClass: _vm.chooseTreeClass }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { staticClass: "auditclass", attrs: { label: "" } },
                [
                  _c(
                    "el-steps",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { active: _vm.active, "finish-status": "success" }
                    },
                    _vm._l(_vm.auditList, function(item, index) {
                      return _c("el-step", {
                        key: index,
                        attrs: { title: item.name }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { staticStyle: { display: "flex", "justify-content": "end" } },
                [
                  _vm.isnotify == true && _vm.subscribeOrder.status < 2
                    ? _c("el-form-item", {
                        attrs: {
                          label: _vm.$t("subscribe.labellist[30]"),
                          prop: "status"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _vm.isnotify == true &&
                                  _vm.subscribeOrder.status == 0
                                    ? _c(
                                        "el-select",
                                        {
                                          staticStyle: {
                                            width: "120px",
                                            "margin-right": "20px"
                                          },
                                          attrs: {
                                            placeholder: _vm.$t(
                                              "SupplierClass.placeholder"
                                            )
                                          },
                                          model: {
                                            value: _vm.auditstatu,
                                            callback: function($$v) {
                                              _vm.auditstatu = $$v
                                            },
                                            expression: "auditstatu"
                                          }
                                        },
                                        _vm._l(_vm.auditstatulist1, function(
                                          item,
                                          index
                                        ) {
                                          return _c("el-option", {
                                            key: index,
                                            style: { color: item.color },
                                            attrs: {
                                              label: item.label,
                                              value: item.value
                                            }
                                          })
                                        }),
                                        1
                                      )
                                    : _vm._e()
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          1237632682
                        )
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isLook == false
                    ? _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            disabled: !_vm.isEdit && _vm.auditList.length <= 0
                          },
                          on: {
                            click: function($event) {
                              return _vm.submitShop()
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t\t" +
                              _vm._s(
                                _vm.isEdit
                                  ? _vm.$t("GoodsList.xiugai")
                                  : _vm.$t("GoodsList.add")
                              ) +
                              "\n\t\t\t\t\t"
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isLook == true && _vm.isEdit == false
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.submitShop1()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("GoodsList.xiugai")))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isnotify == true && _vm.subscribeOrder.status == 0
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.audit()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("audit.buttons[1]")))]
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("picture-swiper", {
        attrs: {
          filesList: _vm.currentGoods.picsList,
          showPreview: _vm.isShowPreview
        },
        on: {
          "update:filesList": function($event) {
            return _vm.$set(_vm.currentGoods, "picsList", $event)
          },
          "update:files-list": function($event) {
            return _vm.$set(_vm.currentGoods, "picsList", $event)
          },
          "update:showPreview": function($event) {
            _vm.isShowPreview = $event
          },
          "update:show-preview": function($event) {
            _vm.isShowPreview = $event
          },
          closeSwiper: _vm.FcloseSwiper
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cb1b578a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb1b578a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/PurchasingManagement/AddSubscribeOrder.vue
// module id = null
// module chunks = 